import{getAddress as t}from"../../utils/address/getAddress.js";async function e(e){return(await e.request({method:"eth_requestAccounts"})).map((e=>t(e)))}export{e as requestAddresses};
